
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
window.gtag = window.gtag || gtag;

window.triggerGAEvent = function(eventAction, eventLabel, eventParams = {}) {
    const userTypeElement = document.querySelector('[data-user-type]');
    const userType = userTypeElement ? userTypeElement.getAttribute('data-user-type') : 'unknown';
    const eventData = {
        'event_label': eventLabel,
        ...eventParams
    };
    gtag('event', `${userType}-${eventAction}`, eventData);
    // console.info('*** event:', `${userType}-${eventAction}`, eventData);
}

function getCookie(name) {
    let cookieArr = document.cookie.split(";");

    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        cookiePair[0] = cookiePair[0].trim();

        if (cookiePair[0] === name) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

function checkPreferenceForValue(value) {
    let preferenceCookie = getCookie('preference');
    if (preferenceCookie) {
        let preferences = preferenceCookie.split(/[-,]/);
        return preferences.includes(value);
    } else {
        return false;
    }
}

window.loadGoogleTagManager = function(trackerId, callback) {
    const existingScript = document.querySelector(`script[src^="https://www.googletagmanager.com/gtag/js?id=${trackerId}"]`);
    if (existingScript) {
        if (callback && typeof callback === 'function') {
            callback();
        }
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackerId;
    document.head.appendChild(script);

    script.onload = function() {
        // Initialize GTM
        gtag('js', new Date());
        gtag('config', trackerId);

        // Call the callback function if provided
        if (callback && typeof callback === 'function') {
            callback();
        }
    }
}

function getTrackerIdFromScript() {
    const script = document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]');
    if (script) {
        const src = script.getAttribute('src');
        const url = new URL(src);
        return url.searchParams.get('id');
    }
    return null;
}

$(document).on('playHpSlider', () => {
    let trackerId = getTrackerIdFromScript() || $('body').data('gtag-tracker');
    if (trackerId && checkPreferenceForValue('statistics')) {
        window.loadGoogleTagManager(trackerId);
    } else {
        console.info("Analytics are disabled")
    }
});

$(document).ready(() => {
    let trackerId = getTrackerIdFromScript() || $('body').data('gtag-tracker');
    if (trackerId && checkPreferenceForValue('statistics')) {
        window.loadGoogleTagManager(trackerId);

        // Clicking on the join button
        $('[data-ga-loc]').each(function() {
            $(this).on('click', function() {
                const itemName = $(this).attr('data-ga-loc') || 'unknown_element';
                const itemCategory = $('body').data('page') || 'unknown_page';
                triggerGAEvent('click_join', 'element', {
                    'element_name': itemName,
                    'element_category': itemCategory
                });
            });
        });


         // CTR Click Tracking
        $('[data-ga-ctr]').each(function() {
            const itemId = $(this).find('h3').text() || 'unknown_id';
            const itemCategory = $('body').data('page') || 'unknown_page';

            // Attach Click Event Listener
            $(this).on('click', function(event) {
                triggerGAEvent('click', 'gallery_ctr', {
                    'item_id': itemId,
                    'item_name': itemId,
                    'item_category': itemCategory
                });
            });
        });

    }
});

// manage cookies popup
$(document).on('click', '#open-adult-modal', event => {
    event.stopPropagation();

    const adultModal = $('.modal[data-modal-type="age-restriction"]');
    const cookies = {};
    $.each(document.cookie.split('; '), function (_, cookie) {
        const parts = cookie.split('=');
        cookies[parts[0]] = parts[1];
    });

    const preferenceValue = cookies.preference || '';
    const preferences = preferenceValue.split('-');

    adultModal.find('input').each(function () {
        const inputName = $(this).attr('name');
        if (preferences.includes(inputName)) {
            $(this).prop('checked', true);
        } else {
            $(this).prop('checked', false);
        }
    });

    adultModal.addClass('active').addClass('change').focus();
    adultModal.find(".modal__button--back").hide();
});